import Vue from 'vue';
import { EventManager } from '../vue/EventManager.js';
import AOS from 'aos';
import VueRouter from 'vue-router';
import VueLazyload from 'vue-lazyload';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import TestComponent from '../vue/TestComponent.vue';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueLazyload);
const router = new VueRouter({ mode: 'history' });

export default {
  init() {
    // JavaScript to be fired on all pages
    let vueArea = document.querySelectorAll('.app');

    let matchingElements = document.getElementsByClassName('vue-disable'),
      hiddenMarkup = [];

    for (var i = 0; i < matchingElements.length; i++) {
      hiddenMarkup.push(matchingElements[i].innerHTML);
      matchingElements[i].innerHTML = '';
    }

    Vue.config.productionTip = false;

    const store = new Vuex.Store({
      state: {
        mobile_menu: false,
        alert_bar_closed: false,
        alert_bar_id: false,
      },
      getters: {},
      mutations: {
        closeAlertBar(state, payload) {
          state.alert_bar_closed = payload;
        },
        alertBarID(state, payload) {
          state.alert_bar_id = payload;
        },
        toggleMobileMenu(state, payload) {
          state.mobile_menu = payload;
        },
      },
      actions: {},
      plugins: [createPersistedState()],
    });

    if (vueArea) {
      vueArea.forEach((element) => {
        new Vue({
          store: store,
          router,
          data: {
            topScrollThreshold: 100,
            isScrolled: false,
            isPageReady: false,
          },

          components: {
            TestComponent,
          },

          methods: {
            onRefreshAos: function () {
              AOS.refresh();
            },
            didScroll() {
              this.isScrolled = window.scrollY > this.topScrollThreshold;
              this.updateTrigger();
            },
          },

          created() {
            window.addEventListener('scroll', this.didScroll);
            // this.updateTrigger();
          },

          destroyed() {
            window.removeEventListener('scroll', this.didScroll);
          },

          mounted() {
            var self = this;
            setTimeout(function () {
              self.isPageReady = true;
              AOS.init();
            }, 500);

            // eslint-disable-next-line no-unused-vars
            self.$Lazyload.$on(
              'loaded',
              function (
                {
                  bindType,
                  el,
                  naturalHeight,
                  naturalWidth,
                  $parent,
                  src,
                  loading,
                  error,
                },
                formCache,
              ) {
                // Lazy loading images can cause AOS to get out of sync because the loaded image changes the height of the content
                // so refreshing it in order to re-calculate trigger points
                EventManager.$emit('should-refresh-aos');
              },
            );


          },
        }).$mount(element);

        /* Re-Attach exclusions
    ---------------------------------------------------------------------------------------------------- */

        for (var ii = 0; ii < matchingElements.length; ii++) {
          matchingElements[ii].innerHTML = hiddenMarkup[ii];
        }
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js